// =====================================================================
// Universal access codes — work on EVERY gated page across the app.
// =====================================================================
// Code-controlled (matches APP_VERSION pattern). Edit here to rotate
// codes globally without hunting through individual pages.
//
//   • UNIVERSAL_ADMIN_CODE  — administrator universal access
//   • UNIVERSAL_CREATOR_CODE — creator (master / override) universal access
//
// Page-specific codes (e.g. "PRESS" on /press, "713love" on downloads)
// live on the individual pages and are independent of these constants.
// =====================================================================

export const UNIVERSAL_ADMIN_CODE = "504to713";
export const UNIVERSAL_CREATOR_CODE = "70126";

export function isUniversalCode(code) {
  return code === UNIVERSAL_ADMIN_CODE || code === UNIVERSAL_CREATOR_CODE;
}
